import { useEffect, useState } from "react";

function ReportsSubmitted() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://getcapsadev.com/api/payments2/getAllReports")
      .then(res => res.json())
      .then(data => {
        let reports = data.data.map(report => {
          return {
            id: report._id,   // ⭐ Important: Needed for download
            reporter: report.engineer_name,
            date: report.created_at2 ? new Date(report.created_at2).toLocaleDateString() : new Date().toLocaleDateString(),
            finding: report.equipment_type_of_faults,
            description: report.technical_suggestion
          };
        });
        setReports(reports);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching reports:", err);
        setLoading(false);
      });
  }, []);

  // ⭐ DOWNLOAD FUNCTION
async function downloadReport(id) {
  try {
    const res = await fetch(
      `https://getcapsadev.com/api/payments2/getReport?id=${id}`
    );
    let data = await res.json();
    data = data.data;

    if (data.url) {
      // Fetch the actual file as BLOB
      const fileRes = await fetch(data.url);
      const blob = await fileRes.blob();

      // Create temporary download link
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "report.pdf"; // You can put dynamic filename here
      document.body.appendChild(a);
      a.click();
      a.remove();

      // Free memory
      window.URL.revokeObjectURL(url);
    } else {
      alert("Unable to download report");
    }
  } catch (error) {
    console.error("Download error:", error);
    alert("Something went wrong");
  }
}


  if (loading) {
    return <h3 className="text-center mt-4">Loading reports...</h3>;
  }

  return (
    <div>
      {reports.map((report, index) => (
        <div key={index} className="card mx-auto w-50 mt-4 mb-4">
          <h5 className="card-header d-flex justify-content-between align-items-center">
            <span>{report.reporter}</span>
            <span>{report.date}</span>
          </h5>

          <div className="card-body">
            <h5 className="card-title">
              <b>FAULTS DETECTED:</b> {report.finding}
            </h5>
            <p className="card-text">
              <b>TECHNICAL SUGGESTION:</b> {report.description}
            </p>

            {/* ⭐ DOWNLOAD BUTTON WITH REPORT ID */}
            <button
              className="btn btn-primary"
              onClick={() => downloadReport(report.id)}
            >
              Download Report
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ReportsSubmitted;
